(function () {
  'use strict';
  var hub = document.querySelector('[data-combo-page]');
  var cards = Array.from(document.querySelectorAll('[data-pack-product]'));
  var url = '/pages/choose-your-pack';
  function shuffled(list) {
    list = list.slice();
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = list[i]; list[i] = list[j]; list[j] = temp;
    }
    return list;
  }
  var groups = [
    ['sadabahar-pan', 'rose-mintiz', 'cardamom-fennel', 'fennel-minitz', 'playful-minty-fennel', 'jammu-mix', 'evergreen-mix'],
    ['anaardana-shots', 'tamarind-candies', 'mango-fun', 'mocktail-shots', 'cumin-nibbles', 'crunchy-coriander-splitz'],
    ['flax-seed-mukhwas', 'nutri-seeds', 'omega-mix', 'in-flight-freshener'],
    ['benaras-meetha', 'kathiawadi-khatta', 'nawab-e-lucknow', 'kolkata-mishti']
  ];
  // Match known flavours, then vary the order. Do not infer personal traits.
  function suggestions(handles) {
    var matching = groups.filter(function (group) { return handles.some(function (h) { return group.includes(h); }); }).flat();
    var pool = shuffled(cards.filter(function (card) { return card.dataset.available !== 'false' && !handles.includes(card.dataset.handle); }));
    pool.sort(function (a, b) { return Number(matching.includes(b.dataset.handle)) - Number(matching.includes(a.dataset.handle)); });
    var regular = pool.filter(function (c) { return Number(c.dataset.price) === 22500; }).slice(0, 2);
    var premium = pool.filter(function (c) { return Number(c.dataset.price) === 26000; }).slice(0, 1);
    return shuffled(regular.concat(premium));
  }
  if (hub) {
    var step2 = hub.querySelector('[data-combo-step2]');
    var dial = hub.querySelector('[data-combo-dial]');
    var say = hub.querySelector('[data-combo-say]');
    var fillTitle = hub.querySelector('[data-combo-fill-title]');
    var bar = document.querySelector('[data-combo-sticky]');
    var barTitle = bar && bar.querySelector('[data-combo-sticky-title]');
    var hero = hub.querySelector('.combo-hero');
    var chosen = 0;
    var storyShelf = hub.querySelector('[data-story-shelf]');
    var storySignature = '';
    function updateStory() {
      if (!storyShelf) return;
      var picked = [];
      cards.forEach(function (card) {
        var count = Number(card.querySelector('[data-pack-count]').textContent) || 0;
        for (var i = 0; i < count; i++) picked.push(card);
      });
      var signature = picked.map(function (card) { return card.dataset.handle; }).join(',');
      if (signature === storySignature && storyShelf.children.length) return;
      storySignature = signature;
      var n = picked.length;
      hub.querySelector('[data-story-title]').textContent = n === 0 ? 'Start with a favourite.' : n === 1 ? 'What goes with it?' : n < 4 ? 'Your flavours, together.' : 'Ready for your next mehfil.';
      var heritage = picked.length && picked.every(function (card) { return groups[3].includes(card.dataset.handle); });
      hub.querySelector('[data-story-copy]').textContent = heritage && n === 2 ? 'Your Heritage pair is ₹450.' : heritage && n === 3 ? 'Your Heritage trio is ₹680.' : heritage && n === 4 ? 'All four Heritage cities are ₹850.' : n === 0 ? 'Add products below. Mix flavours or repeat a favourite.' : n === 1 ? 'Choose one more product to complete your pack.' : n === 2 ? 'Keep this pair, or add a third flavour.' : n === 3 ? 'Your pack saves 20%. A fourth product makes the ₹59 Potli available.' : n + ' products selected. The ₹59 Mehfil Potli is optional.';
      storyShelf.replaceChildren();
      for (var slot = 0; slot < Math.max(4, Math.min(6, n)); slot++) {
        var item = document.createElement('span');
        if (picked[slot]) {
          var photo = picked[slot].querySelector('img').cloneNode();
          photo.alt = ''; photo.width = 72; photo.height = 90;
          item.append(photo); item.className = 'is-filled';
        } else { item.textContent = '+'; }
        storyShelf.append(item);
      }
      if (n > 6) { var more = document.createElement('small'); more.textContent = '+' + (n - 6); storyShelf.append(more); }
    }
    var selectionGrid = hub.querySelector('.wl-pack-grid');
    if (selectionGrid && storyShelf) {
      new MutationObserver(updateStory).observe(selectionGrid, {subtree:true, childList:true, characterData:true});
      updateStory();
    }

    /* Choosing a size is the only decision on this page. It sets the target the
       builder counts towards and, because the paired combinations are already
       grouped into 2, 3 and 4 bottle tabs, it filters those at the same time.
       That is what turns two competing routes into one path with a shortcut. */
    function choose(size, scroll) {
      chosen = size;
      step2.hidden = false;
      if (!hub.querySelector('.combo-switch [aria-current]')) {
        hub.querySelector('[data-combo-ready]').hidden = true;
        hub.querySelector('.combo-switch [data-combo-entry="build"]').setAttribute('aria-current', 'true');
      }
      var mark = null;
      hub.querySelectorAll('[data-combo-size]').forEach(function (b) {
        var on = Number(b.dataset.comboSize) === size;
        b.setAttribute('aria-pressed', String(on));
        if (on && b.dataset.from) mark = b;
      });
      /* The shelf shows the pack: bottles beyond the chosen size step back. */
      if (dial) { dial.dataset.chosen = String(size); delete dial.dataset.preview; }
      if (say && mark) {
        say.innerHTML = '<b>' + mark.querySelector('b').textContent + '</b>, ' +
          '<em>' + mark.dataset.rate + '% off</em>, from ' + mark.dataset.from + '.' +
          (size < 4 ? ' Add an optional Potli with 4+ bottles for \u20b959.' : ' Optional Mehfil Potli: +\u20b959.');
      }
      if (fillTitle) fillTitle.textContent = 'Fill your pack of ' + size;
      if (window.wellubiaPack) window.wellubiaPack.setTarget(size);
      var tab = hub.querySelector('[data-ready-tab="' + size + '"]');
      if (tab) tab.click();
      if (barTitle) barTitle.textContent = size + ' bottles, save ' + (size > 2 ? 20 : 15) + '%';
      if (history.replaceState) { var nextUrl = new URL(location.href); nextUrl.searchParams.set('size', size); history.replaceState(null, '', nextUrl.pathname + nextUrl.search + nextUrl.hash); }
      if (scroll !== false) step2.scrollIntoView({ behavior: prefersMotion() ? 'auto' : 'smooth', block: 'start' });
    }
    function prefersMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function shopMode(mode, scroll) {
      if (!chosen) choose(2, false);
      hub.querySelector('[data-combo-ready]').hidden = mode !== 'ready';
      hub.querySelector('[data-combo-build]').hidden = mode !== 'build';
      hub.querySelectorAll('[data-combo-entry]').forEach(function (link) {
        if (link.dataset.comboEntry === mode) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (scroll) step2.scrollIntoView({behavior: prefersMotion() ? 'auto' : 'smooth', block: 'start'});
    }
    hub.querySelectorAll('[data-combo-entry]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        shopMode(link.dataset.comboEntry, true);
        history.replaceState(null, '', location.pathname + location.search + '#' + link.dataset.comboEntry);
      });
    });
    document.querySelectorAll('[data-combo-size]').forEach(function (b) {
      b.addEventListener('click', function () { choose(Number(b.dataset.comboSize), true); });
      /* Hovering a mark previews how far the shelf fills, without committing. */
      if (!dial || !b.dataset.from) return;
      b.addEventListener('mouseenter', function () { dial.dataset.preview = b.dataset.comboSize; });
      b.addEventListener('focus', function () { dial.dataset.preview = b.dataset.comboSize; });
      b.addEventListener('mouseleave', function () { delete dial.dataset.preview; });
      b.addEventListener('blur', function () { delete dial.dataset.preview; });
    });
    var resize = hub.querySelector('[data-combo-resize]');
    if (resize) resize.addEventListener('click', function () {
      hero.scrollIntoView({ behavior: prefersMotion() ? 'auto' : 'smooth', block: 'start' });
    });

    /* Seventeen bottles in one run is above every recommendation for a bundle
       selector. These four tabs are the collections the store already keeps. */
    hub.querySelectorAll('[data-pack-family]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        hub.querySelectorAll('[data-pack-family]').forEach(function (other) {
          var on = other === tab;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-selected', String(on));
        });
        if (window.wellubiaPack) window.wellubiaPack.filter(tab.dataset.packFamily);
      });
    });

    /* Arriving from a product page pre-picks that bottle, so a size is already
       implied. Otherwise honour ?size= and leave the question standing. */
    var params = new URLSearchParams(location.search);
    var asked = Number(params.get('size'));
    if ([2, 3, 4].indexOf(asked) > -1) choose(asked, false);
    else if (params.get('product') || location.hash === '#build') choose(2, false);
    if (chosen || location.hash === '#ready') shopMode(location.hash === '#ready' ? 'ready' : 'build', false);

    var reveals = hub.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          watcher.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      reveals.forEach(function (el) { watcher.observe(el); });
    }

    /* One offer bar on small screens, once the question has scrolled away. */
    if (bar && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
      }, { threshold: 0 }).observe(hero);
      var cta = bar.querySelector('[data-combo-sticky-cta]');
      if (cta) cta.addEventListener('click', function (event) {
        if (chosen) return;
        event.preventDefault();
        choose(4, true);
      });
    }
  }

  var summary = document.querySelector('.cart-summary');
  if (summary && cards.length) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart'); return r.json();
    }).then(function (cart) {
      var handles = [];
      var count = 0;
      function countItem(item) {
        if (item.item_components && item.item_components.length) { item.item_components.forEach(countItem); return; }
        if (cards.some(function (c) { return c.dataset.handle === item.handle; })) { count += item.quantity; handles.push(item.handle); }
      }
      cart.items.forEach(countItem);
      if (!count || count >= 4) return;
      var picks = suggestions(handles);
      if (!picks.length) return;
      var box = document.createElement('section');
      box.className = 'combo-cart-suggestions';
      var title = document.createElement('p');
      var paanPair = count === 2 && handles.every(function (h) { return h === 'sadabahar-pan'; });
      title.textContent = count === 1 ? 'Choose one more bottle to complete your combo.' : count === 2 ?
        (paanPair ? 'Your Paan pair saves 20%. Add another flavour if you like.' : 'Add a third bottle and save 20% on the bottles.') : 'Add a fourth bottle to get the Mehfil Potli option for ₹59.';
      var choices = document.createElement('div'); choices.className = 'combo-cart-options';
      var status = document.createElement('p'); status.setAttribute('role', 'status');
      picks.forEach(function (card) {
        var button = document.createElement('button'); button.type = 'button';
        var img = card.querySelector('img').cloneNode(); img.width = 48; img.height = 48;
        var label = document.createElement('span'); label.textContent = 'Add ' + card.dataset.title;
        var price = document.createElement('small'); price.textContent = '₹' + Number(card.dataset.price) / 100 + ' before pack discount';
        label.append(price); button.append(img, label); choices.append(button);
        button.addEventListener('click', function () {
          choices.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          status.textContent = 'Adding bottle…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(card.dataset.variant), quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
            .then(function () { location.reload(); })
            .catch(function () { status.textContent = 'Could not add this bottle. Please try again.'; choices.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); });
        });
      });
      box.append(title, choices, status);
      summary.insertBefore(box, summary.querySelector('.checkout'));
      summary.querySelectorAll('[data-cart-rescue-add]').forEach(function (b) { b.hidden = true; });
    }).catch(function () { /* Keep existing cart controls if suggestions cannot load. */ });
  }

  // Show the choice once for identifiable paid visits, outside an active cart or selector.
  var query = new URLSearchParams(location.search);
  var paid = /^(cpc|ppc|paid|paid_social|paid-social|display|retargeting)$/i.test(query.get('utm_medium') || '') ||
    ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid', 'twclid', 'epik'].some(function (key) { return query.has(key); });
  if (!paid || hub || location.pathname === '/cart' || /\/pages\/(b2b|gifting|thank-you)/.test(location.pathname)) return;
  var dismissed = 0;
  try { dismissed = Number(localStorage.getItem('wl-combo-dismissed')); } catch (_) {}
  if (Date.now() - dismissed < 7 * 86400000) return;
  /* An advertisement often opens in a tab behind the one being read. Giving up
     at the five second mark meant those visits never saw this at all, so the
     wait continues until the page is actually looked at. */
  function whenVisible(run) {
    if (!document.hidden) return run();
    document.addEventListener('visibilitychange', function once() {
      if (document.hidden) return;
      document.removeEventListener('visibilitychange', once);
      setTimeout(run, 1200);
    });
  }
  setTimeout(function () { whenVisible(showOffer); }, 5000);
  function showOffer() {
    if (document.querySelector('.wl-pack-locked, .wl-overlay-locked, [role="dialog"][aria-hidden="false"]')) return;
    var dismissedNow = 0;
    try { dismissedNow = Number(localStorage.getItem('wl-combo-dismissed')); } catch (_) {}
    if (Date.now() - dismissedNow < 7 * 86400000) return;
    var overlay = document.createElement('div'); overlay.className = 'combo-popup';
    overlay.innerHTML = '<section role="dialog" aria-modal="true" aria-labelledby="comboPopupTitle">' +
      '<button type="button" aria-label="Close combo offer">×</button>' +
      '<p class="kicker">Two bottles or more</p>' +
      '<h2 id="comboPopupTitle">Save up to 25% on a combination.</h2>' +
      '<p>Take a combination we have already paired, or choose every bottle yourself.</p>' +
      '<ul><li>2 bottles save 15%</li><li>3 bottles save 20%</li><li>4 bottles add the Mehfil Potli for ₹59</li><li>Free delivery across India</li></ul>' +
      '<a href="' + url + '#ready">See ready combos</a><a href="' + url + '#build">Make my combo</a></section>';
    var previous = document.activeElement;
    function remember() { try { localStorage.setItem('wl-combo-dismissed', String(Date.now())); } catch (_) {} }
    function close() { remember(); overlay.remove(); window.WellubiaScrollLock.unlock(); if (previous) previous.focus(); }
    overlay.querySelector('button').addEventListener('click', close);
    overlay.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', remember); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var targets = Array.from(overlay.querySelectorAll('button,a'));
        if (e.shiftKey && document.activeElement === targets[0]) { e.preventDefault(); targets[targets.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === targets[targets.length - 1]) { e.preventDefault(); targets[0].focus(); }
      }
    });
    document.body.append(overlay); window.WellubiaScrollLock.lock(); overlay.querySelector('button').focus();
  }
})();
